import React from 'react'
import EditMenu from '../../../components/organisms/admin/menu/EditMenu'

type Props = {}

const EditMenuPage = (props: Props) => {
  return (
    <EditMenu />
  )
}

export default EditMenuPage